import { inject } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  RouterStateSnapshot,
  Router
} from '@angular/router';

export namespace clientFinalGuard {
  export const canActivate: CanActivateFn = (): boolean => {
    const _localStorageService = inject(LocalStorageService);
    const _router = inject(Router);

    const connectedUser = _localStorageService.getData('userConnected');
    const typeintervenant = _localStorageService.getData('typeintervenant');
    const companyRoleIdclient = _localStorageService.getData('roleUserclient');
    
    if (companyRoleIdclient === '9' || typeintervenant ==='3') {
      return true;  
    } else {
      _router.navigate(['/404']); 
      return false; 
    }
  };
  export const canActivateChild: CanActivateChildFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => canActivate(route, state);
}
